export const CoreInitiativesTasksLinkName = 'CoreInitiativesTasksLink';
